 import API from ".";

 //portfolio Summary EMI
 export const generatePortfolioSummaryEMI = async (filters: any) => {
    try {
      const fromDate = filters.fromDate ?? "";
      const toDate = filters.toDate ?? "";
      const period = filters.periodWithOutDay ?? "";
      const state = filters.state ?? "";
      const territory = filters.territory ?? "";
      const cluster = filters.cluster ?? "";
      const branch = filters.branch ?? "";
  
      const response = await API.get(`generate/portfolio_summary/emi_list?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };

//PortfolioMovementEMI
  export const generatePortfolioMovementEMI = async (filters: any) => {
    try {
      const fromDate = filters.fromDate ?? "";
      const toDate = filters.toDate ?? "";
      const period = filters.periodWithOutDay ?? "";
      const state = filters.state ?? "";
      const territory = filters.territory ?? "";
      const cluster = filters.cluster ?? "";
      const branch = filters.branch ?? "";
  
      const response = await API.get(`generate/portfolio_summary/list_principal_net_moment_emi?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };


 export const generateDeliquencyLinechartEMI = async (filters: any) => {
    try {
      const fromDate = filters.fromDate ?? "";
      const toDate = filters.toDate ?? "";
      const period = filters.periodWithOutDay ?? "";
      const state = filters.state ?? "";
      const territory = filters.territory ?? "";
      const cluster = filters.cluster ?? "";
      const branch = filters.branch ?? "";
  
      const response = await API.get(`generate/portfolio_delinquency/list_percentage_coincidental_emi?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };

  export const flowRatesByBranchEmi = async (filters: any) => {
    try {
      const fromDate = filters.fromDate ?? "";
      const toDate = filters.toDate ?? "";
      const period = filters.periodWithOutDay ?? "";
      const state = filters.state ?? "";
      const territory = filters.territory ?? "";
      const cluster = filters.cluster ?? "";
      const branch = filters.branch ?? "";
  
      const response = await API.get(`generate/portfolio_delinquency/list_flow_rates_by_emi?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };
  

  export const generatePortfolioSummaryEmi = async (filters: any) => {
    try {
      const fromDate = filters.fromDate ?? "";
      const toDate = filters.toDate ?? "";
      const period = filters.periodWithOutDay ?? "";
      const state = filters.state ?? "";
      const territory = filters.territory ?? "";
      const cluster = filters.cluster ?? "";
      const branch = filters.branch ?? "";
  
      const response = await API.get(`generate/portfolio_summary/list?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}&product_type=M`);
      return response.data;
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  };